import "./App.css";
import React from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

/* =====================
   PÚBLICO
===================== */
import HomeLandpage from  "./pages/Home/PaginaInstitucional";
import Home from "./pages/Home";
import HeroAdmin from "./pages/Admin/HeroAdmin"
import Agendamento from "./pages/agendamento";
import Posts from "./pages/Posts";
import Admin from "./pages/Admin";
import Team from "./pages/Team";
import Agendados from "./pages/Agendados";
import Login from "./pages/Login";
import Cadastrar from "./pages/cadastrar";
import Register from "./pages/RegisterUser";
import Setting from "./pages/menu-consulta";
import CadastrarConsulta from "./pages/menu-consulta/cadastrar-menu-consulta";
import EditarConsulta from "./pages/menu-consulta/editar-menu-consulta";
import Mensagem from "./pages/Home/mensagem";
import Sobre from "./pages/Sobre/QuemSouEu";
import Equipe from "./pages/Sobre/Equipe";

import Article from "./pages/Article/Article";
import Criminal from "./pages/Criminal";
import NotFound from "./pages/NotFound/NotFound";

/* =====================
   AUTH
===================== */
import LoginApp from "./app/login/LoginApp";
import ForgotPassword from "./app/login/ForgotPassword";
import ResetPassword from "./app/login/ResetPassword";

/* =====================
   ADMIN
===================== */
import DashboardGeral from "./app/admin/DashboardGeral";
import ProcessosList from "./app/processos/ProcessosList";
import ProcessoDetalhe from "./app/processos/ProcessoDetalhe";
import DashboardPrazos from "./app/admin/PrazosAdmin";
import CadastrarCliente from "./app/admin/CadastrarCliente";
import ClientesAdmin from "./app/admin/ClientesAdmin";
import ProcessoNovo from "./app/admin/NovoProcesso";
import PrazosNovo from "./app/admin/NovoPrazo";

/* =====================
   CLIENTE
===================== */
import DashboardCliente from "./app/cliente/DashboardCliente";
import ProcessosCliente from "./app/cliente/ProcessosCliente";
import ProcessoClienteDetalhe from "./app/cliente/ProcessoClienteDetalhe";
import PrazosCliente from "./app/cliente/Prazos";
import ClientesDetalhe from "./app/admin/ClientesDetalhe";

/*================================
LAND PAGES
=================================*/
import LandPages from "./lp/Index";

function App() {
  const navigate = useNavigate();

  const goHome = () => navigate("/");

  return (
    <Routes>

      {/* =====================
          PÚBLICO
      ===================== */}
      <Route path="/" element={<HomeLandpage/> } />
      <Route path="/home" element={<Home/>} />
      <Route path="/admin/hero" element={<HeroAdmin/>}/>
      <Route path="/agendamento" element={<Agendamento />} />
      <Route path="/login" element={<Login toggleModalLogin={goHome} />} />
      <Route path="/cadastrar" element={<Cadastrar toggleModalCadastro={goHome} />} />
      <Route path="/register" element={<Register toggleModalCadastro={goHome} />} />
      <Route path="/posts" element={<Posts />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/team" element={<Team />} />
      <Route path="/sobre" element={<Sobre />} />
      <Route path="/equipe" element={<Equipe/>}/>
      <Route path="/agendados" element={<Agendados />} />
      <Route path="/menu-consulta" element={<Setting />} />
      <Route path="/cadastrar-menu-consulta" element={<CadastrarConsulta />} />
      <Route path="/editar-menu-consulta/:id" element={<EditarConsulta />} />
      <Route path="/mensagem" element={<Mensagem />} />
      <Route path="/article/:slug" element={<Article />} />
      <Route path="/criminal.html" element={<Criminal />} />

      {/* =====================
          AUTH APP
      ===================== */}
      <Route path="/app/login" element={<LoginApp />} />
      <Route path="/app/esqueci-senha" element={<ForgotPassword />} />
      <Route path="/app/reset-senha" element={<ResetPassword />} />

      {/* =====================
          ADMIN
      ===================== */}
      <Route path="/app/admin/dashboard" element={<DashboardGeral />} />
      <Route path="/app/admin/processos" element={<ProcessosList />} />
      <Route path="/app/admin/processos/novo" element={<ProcessoNovo />} />
      <Route path="/app/admin/processos/:id" element={<ProcessoDetalhe />} />
      <Route path="/app/admin/prazos" element={<DashboardPrazos />} />
      <Route path="/app/admin/prazos/novo" element={<PrazosNovo />} />
      <Route path="/app/admin/clientes" element={<ClientesAdmin />} />
      <Route path="/app/admin/clientes/novo" element={<CadastrarCliente />} />
      <Route path="/app/admin/clientes/:id " element= {<ClientesDetalhe/>} />

      {/* =====================
          CLIENTE
      ===================== */}
      <Route path="/app/cliente/dashboard" element={<DashboardCliente />} />
      <Route path="/app/cliente/processos" element={<ProcessosCliente />} />
      <Route path="/app/cliente/processos/:id" element={<ProcessoClienteDetalhe />} />
      <Route path="/app/cliente/prazos" element={<PrazosCliente />} />

      
      {/* =====================
          LandPages
      ===================== */}
      <Route path="/admin/lp/landpages"  element = {<LandPages/>}/>

      {/* =====================
          404
      ===================== */}
      <Route path="*" element={<NotFound />} />

    </Routes>
  );
}

export default App;
